import type { IconSvgObject } from './types';

const BluetoothConnectedIcon: IconSvgObject = [
  ["path", { d: "M7 17L17 6.99997L12.0014 3V21L17 17L7 6.99997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 12H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 12H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BluetoothConnectedIcon;
